import React from 'react';
import './Card.css';
import {Helmet} from "react-helmet";
import { CardLink } from './cardElement';


// export const CardNFTOutsideMarket = ({name, sales, image, uuid, video, openSeaLink, linkTo, mapKey, isImg}) => {
//   return (
//     <a key={mapKey} href={linkTo ? linkTo : `/markets/${uuid}`} style={{color: "transparent"}}>
//       <div className="cardNFT dib tc pa3 bg-white ba bw2">
//         <div style={{
//           fontSize: "13px",
//           position: "absolute",
//           left: "12px",
//           top: "12px",
//           color: "black",
//           fontWeight: "800",
//           fontStyle: "italic",
//           fontVariantCaps: "small-caps"
//         }}>{isImg ? "ANIMATED NFT" : "NFT PICTURE"}</div>
//         <div className={"loading"}>&nbsp;</div>
//         <div className='image-box-nft' style={{marginTop: "30px"}}>
//           <img src={image} alt={name}/>

//         </div>
//         <div className='desc pv2 black'>
//           <p className='f6 fw6' style={{fontSize: "16px", fontWeight: "800", fontVariantCaps: "small-caps"}}>{name}</p>
//           <p className='f6'>{sales} ETH</p>
//         </div>
//         <div style={{position: "absolute", top: 0, right: 0}}>
//           <div style={{display: "flex", gap: "10px", marginLeft: "30px"}}>
//             <a href={`https://rarible.com/token/` + uuid.slice(9)} style={{color: "white", fontWeight: 400}}>
//               <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <rect width="40" height="40" rx="8" fill="#FEDA03"></rect>
//                 <path
//                   d="M27.6007 19.8536C28.8607 19.5262 29.9817 18.5838 29.9817 16.6889C29.9817 13.5342 27.3031 12.8 23.8706 12.8H10.2V27.0064H15.9539V22.185H22.7793C23.8309 22.185 24.446 22.6016 24.446 23.6334V27.0064H30.2V23.4548C30.2 21.5203 29.1087 20.3 27.6007 19.8536ZM22.8785 18.3556H15.9539V16.9667H22.8785C23.6325 16.9667 24.0888 17.0659 24.0888 17.6612C24.0888 18.2564 23.6325 18.3556 22.8785 18.3556Z"
//                   fill="black"></path>
//               </svg>
//             </a>
//             <a href={openSeaLink} style={{color: "white", fontWeight: 400}}>
//               <img alt="" style={{
//                 height: "40px",
//                 maxWidth: "40px"
//               }} src={"https://opensea.io/static/images/logos/opensea.svg"}/>
//             </a>
//           </div>
//         </div>

//       </div>
//     </a>

//   );
// };

export const CardNFT = ({name, sales, image, uuid, openSeaLink, video, linkTo, mapKey, isImg}) => {
  return (
    <CardLink key={mapKey} to={`/markets/${uuid}`} style={{color: "transparent"}}>
      <div className="cardNFT dib tc pa3 bg-white ba bw2">
        <div style={{
          fontSize: "13px",
          position: "absolute",
          left: "12px",
          top: "12px",
          color: "black",
          fontWeight: "800",
          fontStyle: "italic",
          fontVariantCaps: "small-caps"
        }}>{isImg ? "ANIMATED NFT" : "NFT PICTURE"}</div>
        <div className={"loading"}>&nbsp;</div>
        <div className='image-box-nft' style={{marginTop: "30px"}}>

          <img src={image} alt={name}/>

        </div>
        <div className='desc pv2 black'>
          <p className='f6 fw6' style={{fontSize: "16px", fontWeight: "800", fontVariantCaps: "small-caps"}}>{name}</p>
          <p className='f6'>{sales} ETH</p>
        </div>
        <div style={{position: "absolute", top: 0, right: 0}}>
          <div style={{display: "flex", gap: "10px", marginLeft: "30px"}}>
            <a href={`https://rarible.com/token/` + uuid.slice(9)} style={{color: "white", fontWeight: 400}}>
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="8" fill="#FEDA03"></rect>
                <path
                  d="M27.6007 19.8536C28.8607 19.5262 29.9817 18.5838 29.9817 16.6889C29.9817 13.5342 27.3031 12.8 23.8706 12.8H10.2V27.0064H15.9539V22.185H22.7793C23.8309 22.185 24.446 22.6016 24.446 23.6334V27.0064H30.2V23.4548C30.2 21.5203 29.1087 20.3 27.6007 19.8536ZM22.8785 18.3556H15.9539V16.9667H22.8785C23.6325 16.9667 24.0888 17.0659 24.0888 17.6612C24.0888 18.2564 23.6325 18.3556 22.8785 18.3556Z"
                  fill="black"></path>
              </svg>
            </a>
            <a href={openSeaLink} style={{color: "white", fontWeight: 400}}>
              <img alt="" style={{
                height: "40px",
                maxWidth: "40px"
              }} src={"https://opensea.io/static/images/logos/opensea.svg"}/>
            </a>
          </div>
        </div>
      </div>
    </CardLink>

  );
};

export const ProductCard = ({
                              name,
                              createdAt,
                              image,
                              video,
                              desc,
                              id,
                              bestSellOrderMakePrice,
                              makeStock,
                              totalStock,
                              openSeaLink,
                              isImg,

                            }) => {
  return (
    <>
      <Helmet>
        <title>{name} · PopBeLLy</title>
      </Helmet>
      <div className='productCard tc bg-black white pv5'>
        <div className="card-header w-100 pa3">
          <h1>{name}</h1>
          <div><small>created: {createdAt.split('T')[0]}</small></div>
          {/*<p> {properties} </p>*/}
        </div>
        <div className="card-body pv4">
          <div className="card-img w-50 card-video"
               style={{maxWidth: "620px", marginLeft: "auto", position: "relative"}}>
            <div className={"loading"} style={{margin: "auto"}}>&nbsp;</div>
            <div style={{position: "relative", zIndex: 2}}>
              {!isImg
                ? <video muted autoPlay loop playsInline poster={image}>
                  <source src={video} type={'video/webm'}/>
                  <source src={video} type={'video/mp4'}/>
                </video>
                : <img src={image} alt={name}/>

              }


            </div>
          </div>
          {/*<ThumbnailsDiv>*/}
          {/*  {*/}
          {/*    isImg?*/}
          {/*      <img src={IMAGE_URL+image.split(",")[1]} alt="NFTcard" />*/}
          {/*      :<video src={IMAGE_URL+image.split(",")[1]} controls muted autoPlay/>*/}
          {/*  }*/}
          {/*</ThumbnailsDiv>*/}
          <div className="card-desc w-50 tl" style={{maxWidth: "620px", marginRight: "auto", paddingRight: "1rem"}}>
            <div className="desc-header"><h2>{name}</h2></div>
            <div className="desc pv4"><p>{desc}</p></div>
            {/*<div className="desc-edition pb4"><p>{edition}</p></div>*/}
            <div className="desc-sales pb5">
              <small>Pricing:</small>
              <div style={{display: "flex", marginTop: "5px"}}>
                <div style={{display: "flex", alignItems: "center"}}><img
                  src={"https://rarible.com/9b703a21b9f93a1f0065.svg"} alt={""}
                  style={{height: "40px", maxWidth: "40px"}}/> <span
                  style={{marginLeft: "10px"}}>{bestSellOrderMakePrice} ETH</span></div>
              </div>
            </div>
            <div style={{display: "flex", gap: "2rem", marginLeft: "30px"}}>
              <a href={`https://rarible.com/token/` + id.slice(9)} style={{color: "white", fontWeight: 400}}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" rx="8" fill="#FEDA03"></rect>
                  <path
                    d="M27.6007 19.8536C28.8607 19.5262 29.9817 18.5838 29.9817 16.6889C29.9817 13.5342 27.3031 12.8 23.8706 12.8H10.2V27.0064H15.9539V22.185H22.7793C23.8309 22.185 24.446 22.6016 24.446 23.6334V27.0064H30.2V23.4548C30.2 21.5203 29.1087 20.3 27.6007 19.8536ZM22.8785 18.3556H15.9539V16.9667H22.8785C23.6325 16.9667 24.0888 17.0659 24.0888 17.6612C24.0888 18.2564 23.6325 18.3556 22.8785 18.3556Z"
                    fill="black"></path>
                </svg>
                <span style={{marginLeft: "10px"}}>
              Get on Rarible</span></a>
              {/*  https://rarible.com/token/0xc9154424B823b10579895cCBE442d41b9Abd96Ed:99816618775492178415113412848638640383758125341899270940663615244789138587664*/}
              {/*  https://opensea.io/assets/0x495f947276749ce646f68ac8c248420045cb7b5e/99816618775492178415113412848638640383758125341899270940663615265679859515393/*/}
              <a href={openSeaLink} style={{color: "white", fontWeight: 400}}><img alt="" style={{
                height: "40px",
                maxWidth: "40px"
              }} src={"https://opensea.io/static/images/logos/opensea.svg"}/> <span style={{marginLeft: "10px"}}>Get on Opensea</span></a>
            </div>
            <div style={{textAlign: "right", marginTop: "25px"}}><small>Stock
              available: {makeStock}/{totalStock}</small></div>
          </div>
        </div>
      </div>
    </>
  );
};
